export const DATA_ETAG_PATTERN = /data-etag=["']([^"']+)["']/i;

export const parseEtag = (source: string): string | undefined => {
  const match = DATA_ETAG_PATTERN.exec(source);
  const etag = match?.[1]?.trim();
  return etag || undefined;
};

export const etagsDiffer = (runningEtag: string, uploadedEtag: string): boolean =>
  Boolean(runningEtag) && Boolean(uploadedEtag) && runningEtag !== uploadedEtag;
